function getColorBrightness(rgbColor) {
  var colorValues = rgbColor.match(/[\d\.]+/g).map(Number);
  return 0.2126 * (colorValues[0] / 255) + 0.7152 * (colorValues[1] / 255) + 0.0722 * (colorValues[2] / 255);
}

function isSimilarToBackground(color) {
  var backgroundColor = 'rgb(255, 255, 255)';

  var colorBrightness = getColorBrightness(color);
  var backgroundColorBrightness = getColorBrightness(backgroundColor);

  return (backgroundColorBrightness / colorBrightness) < 1.5;
}

var SwatchColors = (function() {
  function SwatchColors() {
    this.colors = {};

    this.images = {'saffron': 'url("//www.ruperts.au/cdn/shop/files/Saffron_1_68x.png?v=1303582317570143966")','bayleaf': 'url("//www.ruperts.au/cdn/shop/files/Bayleaf_68x.png?v=6890971206186572523")','russet': 'url("//www.ruperts.au/cdn/shop/files/Russet_68x.png?v=16523246952780521178")','storm': 'url("//www.ruperts.au/cdn/shop/files/Storm_68x.png?v=10638356530362947463")','muscat': 'url("//www.ruperts.au/cdn/shop/files/Muscat_68x.png?v=15950655789475681520")','turquoise-rivers': 'url("//www.ruperts.au/cdn/shop/files/Turquoise_Rivers_68x.png?v=9500566981616277800")','green-fields': 'url("//www.ruperts.au/cdn/shop/files/Green_Fields_68x.png?v=16514949293822542594")','lilac-sunrise': 'url("//www.ruperts.au/cdn/shop/files/Lilac_Sunrise_68x.png?v=5616468518658315970")','pink-blossoms': 'url("//www.ruperts.au/cdn/shop/files/Pink_Blossoms_68x.png?v=16685826852310086806")','red-autumn-leaves': 'url("//www.ruperts.au/cdn/shop/files/Red_Autumn_Leaves_68x.png?v=3787721286247473312")','twilight-blue-skies': 'url("//www.ruperts.au/cdn/shop/files/Twilight_Blue_Skies_68x.png?v=2968576498084839750")','sunshine-yellow': 'url("//www.ruperts.au/cdn/shop/files/Sunshine_Yellow_68x.png?v=10137929492835961802")','summer-sand': 'url("//www.ruperts.au/cdn/shop/files/Summer_Sand_68x.png?v=2576357129271082566")','moss-green': 'url("//www.ruperts.au/cdn/shop/files/Moss_Green_68x.png?v=6946842303278914668")','cranberry': 'url("//www.ruperts.au/cdn/shop/files/Cranberry_68x.png?v=6764787157559711275")','cream': 'url("//www.ruperts.au/cdn/shop/files/Cream_68x.png?v=5806227302840998402")','ivy': 'url("//www.ruperts.au/cdn/shop/files/Ivy_68x.png?v=4295395350369464853")','nutmeg': 'url("//www.ruperts.au/cdn/shop/files/Nutmeg_68x.png?v=3903138728316706491")','bossy-pink': 'url("//www.ruperts.au/cdn/shop/files/Bossy_Pink_68x.png?v=14350768341740565088")','sunny-yellow': 'url("//www.ruperts.au/cdn/shop/files/Sunny_Yellow_68x.png?v=2729699742343616840")','tangerine': 'url("//www.ruperts.au/cdn/shop/files/Tangerine_68x.png?v=9234870309009563930")','sea-spray': 'url("//www.ruperts.au/cdn/shop/files/Sea_Spray_68x.png?v=15007747859325243553")',};

    this.triggers = ['color','colour','couleur','farbe','cor',];
  }

  function setSwatchColor(swatch) {
    var swatchId = swatch.getAttribute('swatch-id');

    if (Object.keys(this.colors).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.colors[swatchId]);

      if (isSimilarToBackground(this.colors[swatchId])) swatch.classList.add('is-similar-to-background');
      if (getColorBrightness(this.colors[swatchId]) > 0.5) {
        swatch.style.setProperty('--tick-color', '#000');
      } else {
        swatch.style.setProperty('--tick-color', '#fff');
      }
      swatch.classList.remove('is-blank');
    }

    if (Object.keys(this.images).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.images[swatchId]);
      swatch.classList.add('is-image');
      swatch.classList.remove('is-blank');
    }
  }
  SwatchColors.prototype.setSwatchColor = setSwatchColor;

  return SwatchColors;
}());

window.theme.swatches = new SwatchColors();

function VariantSwatch() {
  return Reflect.construct(HTMLElement, [], this.constructor);
}

VariantSwatch.prototype = Object.create(HTMLElement.prototype);
VariantSwatch.prototype.constructor = VariantSwatch;
Object.setPrototypeOf(VariantSwatch, HTMLElement);

VariantSwatch.prototype.connectedCallback = function() {
  window.theme.swatches.setSwatchColor(this);
};
customElements.define('variant-swatch', VariantSwatch);
